// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MJgC","field":"styles_field__1OtpQ","fieldCol":"styles_fieldCol__1Ar2k","diffCol":"styles_diffCol__2Yx3w","diff":"styles_diff__lZj70"};